import { render, staticRenderFns } from "./CarsList.vue?vue&type=template&id=7671ee32&scoped=true"
import script from "./CarsList.vue?vue&type=script&lang=js"
export * from "./CarsList.vue?vue&type=script&lang=js"
import style0 from "./CarsList.vue?vue&type=style&index=0&id=7671ee32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7671ee32",
  null
  
)

export default component.exports